import { component } from 'picoapp';
import app from 'app';

import Filter from 'lib/filter';
import productCard from 'lib/product-card';

import FilterTriggers from 'layout/filter-triggers';
import priceSlider from 'lib/price-slider';
import collectionFilter from 'layout/collection-filter';

import { debounce } from 'lodash-es';
import { scrollLock } from 'utils/node';

const Filters = component((node, ctx) => {
  document.addEventListener('filters:loaded', () => {
    const output = node.querySelector('[data-output]');
    const empty = node.querySelector('[data-empty]');

    const clearFilters = node.querySelectorAll('[data-clear-filter]');
    const resets = node.querySelectorAll('[data-reset]');
    const filters = node.querySelector('[data-filters]');
    const closeFilter = document.querySelectorAll('[data-close-filter]');
    const filterTriggers = node.querySelectorAll('[data-filter-trigger]');
    const items = node.querySelector('[data-filter-items]');
    const overlay = node.querySelector('.overlay');

    const { styleCollections, hideStyles } = filters.dataset;

    filters.hidden = false;
    filters.setAttribute('aria-hidden', 'false');

    /**
     * Init filter
     */

    Filter(node, {
      size: node.dataset.size,
      endpoint: node.dataset.endpoint,
      output,
      productItem: (item) => productCard(item, node.dataset.handle, ctx),
      activeClass: 'is-active',
      pagination: {
        type: 'infinite',
      },
    });

    // Specific search page after using filter
    ctx.on('filter:rendered', () => {
      app.mount(['data-component']);
    });

    // Remount price-slider
    app.mount(['data-util']);

    ctx.on('filter:loaded', () => {
      filterTriggers.forEach((item) => {
        item.hidden = false;
        item.removeAttribute('hidden');
      });
    });

    // Empty state
    ctx.on('filter:rendered', (products) => {
      if (products.products.length === 0) empty.classList.add('is-visible');
      else empty.classList.remove('is-visible');
    });

    // Clear all filters
    clearFilters.forEach((clear) => {
      clear.addEventListener('click', () => {
        node.querySelectorAll('[data-filter-item]').forEach((item) => item.classList.remove('is-active'));
        ctx.emit('filter:start');
        ctx.emit('filter:clear');
      });
    });

    // Reset filter groups
    resets.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        const { reset } = trigger.dataset;
        const filterGroup = node.querySelector(`[data-name="${reset}"]`);
        filterGroup.querySelectorAll('[data-filter-item]').forEach((item) => item.classList.remove('is-active'));

        ctx.emit('filter:start');
      });
    });

    const open = () => {
      filters.classList.add('is-active');
      items.classList.add('is-open');
      overlay.classList.add('overlay--active');
      scrollLock(true);
    };

    const close = () => {
      filters.classList.remove('is-active');
      items.classList.remove('is-open');
      overlay.classList.remove('overlay--active');
      scrollLock(false);
    };

    node.addEventListener('click', (e) => {
      if (!items.contains(e.target) && ![...filterTriggers].includes(e.target)) {
        close();
      }
    });

    filterTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        open();
      });
    });

    // Display second filter when scrolled past first one
    window.addEventListener('scroll', debounce(() => {
      const pos = filterTriggers[0].getBoundingClientRect().top + filterTriggers[0].offsetHeight;

      if (pos < 0) filterTriggers[1].classList.add('is-visible');
      else filterTriggers[1].classList.remove('is-visible');
    }, 100));

    closeFilter.forEach((item) => {
      item.addEventListener('click', () => {
        close();
      });
    });

    if (window.theme.handle !== '') {
      if (JSON.parse(hideStyles).includes(window.theme.handle)) {
        const stylesFilter = filters.querySelector('[data-filter][data-name="styles"]');
        const collectionHeader = node.querySelector('[data-collection-header]');
        stylesFilter.hidden = true;
        collectionHeader.classList.add('no-styles');
      }

      if (JSON.parse(styleCollections).includes(window.theme.handle) || window.theme.template === 'search') {
        const styles = filters.querySelectorAll('[data-styles]:not([hidden])');
        const hiddenStyles = filters.querySelectorAll('[data-styles][hidden]');

        hiddenStyles.forEach((style) => {
          style.removeAttribute('hidden');
        });

        styles.forEach((style) => {
          style.setAttribute('hidden', '');
        });
      }
    }
  });
});

app.add({
  Filters,
  FilterTriggers,
  collectionFilter,
  priceSlider,
});

app.mount();
